// extracted by mini-css-extract-plugin
export default {"otp-text-input-container":"otpInput_otp-text-input-container__oXjPQ","active":"otpInput_active__OX7Ls"};